/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

declare const window: any;

interface ContenidoComponentProps {
  setSelectedCategories: any;
  selectedCategories: any;
  vehiculos: any;
  modelos: any;
}

const ContenidoComponent: React.FC<ContenidoComponentProps> = ({
  setSelectedCategories,
  selectedCategories,
  vehiculos,
  modelos,
}) => {
  const [visibleCategories, setVisibleCategories] = useState<Set<string>>(
    new Set()
  );
  const refs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const info_request_click = (vehiculo: any) => {

    const dataLayerEvent: any = {
      event: "info_request_click",
      comp_product: {
        position: "page",
        vehicle_type: "Car",
        brand: "Hyundai",
        product_condition: vehiculo?.is_new ? "new" : null,
        model: `${
          modelos?.find(
            (e: any) =>
              e.internal?.trim().toLowerCase() ===
              vehiculo?.title?.trim().toLowerCase()
          )?.nombremodelo
        }`,
        version: null,
        fuel_type: null,
        dealer_name: null,
      },
    };

    // Empujar al dataLayer
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
  };

  const file_download = (vehiculo: any) => {
    const dataLayerEvent: any = {
      event: "file_download",
      comp_page: {
        file_name: null,
        link: `${vehiculo?.url_brochure}`,
        vehicle_type: "Car",
        brand: "Hyundai",
        product_condition: vehiculo?.is_new ? "new" : null,
        model: `${
          modelos?.find(
            (e: any) =>
              e.internal?.trim().toLowerCase() ===
              vehiculo?.title?.trim().toLowerCase()
          )?.nombremodelo
        }`,
        file_type: "catalog",
        download_type: "preview",
      },
    };

    // Empujar al dataLayer
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
  };

  const checkInitialVisibility = () => {
    Object.keys(refs.current).forEach((category) => {
      const currentRef = refs.current[category];
      if (currentRef) {
        const rect = currentRef.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          setVisibleCategories((prev) => new Set(prev).add(category));
        }
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const category = entry.target.getAttribute("data-category");
          if (category) {
            setVisibleCategories((prev) => {
              const newVisibleCategories = new Set(prev);
              if (entry.isIntersecting) {
                newVisibleCategories.add(category);
              } else if (entry.boundingClientRect.top > 0) {
                newVisibleCategories.delete(category);
              }
              return newVisibleCategories;
            });
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const timeoutId = setTimeout(() => {
      Object.keys(refs.current).forEach((category) => {
        const currentRef = refs.current[category];
        if (currentRef) {
          observer.observe(currentRef);
        }
      });
      checkInitialVisibility();
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      Object.keys(refs.current).forEach((category) => {
        const currentRef = refs.current[category];
        if (currentRef) {
          observer.unobserve(currentRef);
        }
      });
    };
  }, [vehiculos, selectedCategories]);

  return (
    <div className="contenido-vehiculos-component">
      {vehiculos
        .sort((a: any, b: any) => a.order - b.order)
        .filter(
          (categoria: any) =>
            (selectedCategories === "Todos" && categoria?.is_menu_all) ||
            categoria.category === selectedCategories
        )
        .map((categoria: any) => (
          <div
            className="categoria-contenido-vehiculos-component"
            key={categoria.category}
          >
            <div className="title-categoria-contenido-vehiculos-component">
              {categoria.category}
            </div>
            <div
              className={`vehiculos-categoria-contenido-vehiculos-component ${
                visibleCategories.has(categoria.category) ? "visible" : ""
              }`}
              ref={(el) => (refs.current[categoria.category] = el)}
              data-category={categoria.category}
            >
              {categoria.vehicles_cards
                .sort((a: any, b: any) => {
                  const priseA = parseInt(a.price.replace(/\$|,|\./g, ""));
                  const priseB = parseInt(b.price.replace(/\$|,|\./g, ""));
                  return priseA - priseB;
                })
                .map((vehiculo: any) => (
                  <div
                    className={`vehiculo-categoria-contenido-vehiculos-component ${
                      vehiculo?.is_new ? "new" : ""
                    }`}
                    key={vehiculo?.title}
                  >
                    {vehiculo?.is_new && (
                      <div className="new-vehiculo-categoria-contenido-vehiculos-component">
                        ¡Nuevo!
                      </div>
                    )}
                    <Link
                      to={vehiculo?.url_quote}
                      onClick={() => info_request_click(vehiculo)}
                    >
                      <img
                        className="img-vehiculo-categoria-contenido-vehiculos-component"
                        src={`https://manager.hyundaicolombia.co/${vehiculo?.image?.url}`}
                        alt={`Imagen del vehículo ${vehiculo?.title}`}
                      />
                    </Link>

                    <h1 className="label-vehiculo-categoria-contenido-vehiculos-component">
                      {vehiculo?.title}
                    </h1>
                    <p className="precio-vehiculo-categoria-contenido-vehiculos-component">
                      desde {vehiculo?.price}
                    </p>
                    <div className="detalle-vehiculo-categoria-contenido-vehiculos-component">
                      <div>
                        <img
                          src={`https://manager.hyundaicolombia.co/${vehiculo?.icon1?.url}`}
                          alt={vehiculo?.text1 || "Combustible"}
                        />
                        <span>{vehiculo?.text1}</span>
                      </div>
                      <div>
                        <img
                          src={`https://manager.hyundaicolombia.co/${vehiculo?.icon2?.url}`}
                          alt={vehiculo?.text2 || "Motor"}
                        />
                        <span>{vehiculo?.text2}</span>
                      </div>
                      <div>
                        <img
                          src={`https://manager.hyundaicolombia.co/${vehiculo?.icon3?.url}`}
                          alt={vehiculo?.text3 || "Garantía"}
                        />
                        <span>{vehiculo?.text3}</span>
                      </div>
                    </div>

                    <div className="opcion-vehiculo-categoria-contenido-vehiculos-component">
                      <Link
                        to={vehiculo?.url_quote}
                        onClick={() => info_request_click(vehiculo)}
                        className="cotiza-opcion-vehiculo-categoria-contenido-vehiculos-component"
                      >
                        Cotiza
                      </Link>
                      <Link
                        to={vehiculo?.url_reserve || "#"}
                        className={`reserva-opcion-vehiculo-categoria-contenido-vehiculos-component ${
                          !vehiculo?.url_reserve ? "inactive" : ""
                        } ${!vehiculo?.url_brochure ? "active" : ""}`}
                      >
                        Reserva
                      </Link>
                      <a
                        href={vehiculo?.url_brochure || "#"}
                        onClick={() => file_download(vehiculo)}
                        target="_blank"
                        className={`pdf-opcion-vehiculo-categoria-contenido-vehiculos-component ${
                          !vehiculo?.url_brochure ? "inactive" : ""
                        } ${!vehiculo?.url_reserve ? "active" : ""}`}
                      >
                        Ficha técnica
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default ContenidoComponent;
